import { GetBirthdateType as BirthdateApiType } from 'src/api/generated/touring/types';
import { BirthdateType } from 'src/api/mapping/common';

export const mapBirthdate = (birthday: BirthdateApiType): BirthdateType => {
  return {
    month: birthday.month,
    day: birthday.day,
    year: birthday.year,
  };
};
